// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__Xp9cB","additionalInfo":"AgreementModal_additionalInfo__biGN_"};